import React from "react";
import { EmptyModal, Table } from "../../../../components/core";

export default function ViewPackageHistoryModal({
	open,
	onClose,
	data = [],
	headers = [
		{ header_name: "Agent Mobile Number", header_key: "partnerAgentMobile" },
		{ header_name: "Recipient Mobile Number", header_key: "recipientMobile" },
		{ header_name: "Locker Name", header_key: "lockerName" },
		{ header_name: "Package Date", header_key: "packageDate" },
		{ header_name: "Waybill Number", header_key: "waybillNumber" },
		{ header_name: "Package State", header_key: "packageState" },
		{ header_name: "Service", header_key: "service" },
	],
}) {
	return (
		<EmptyModal open={open} onClose={onClose}>
			<p className="font-bold text-xl text-center mb-2">
				Current User Package History for the last 10 days
			</p>
			<Table headers={headers} items={data} />
		</EmptyModal>
	);
}
